const firebasePromise = new Promise((resolve,reject)=>{
	if(typeof document!== "undefined"){
		document.onreadystatechange = function () {
			if (document.readyState === "interactive" || document.readyState === "complete") {
				require.ensure(['firebase/app.js','firebase/auth.js'], (require) => {
					const initFirebase = function() {
						window.firebase = require('firebase/app.js');
						firebase.auth = require('firebase/auth.js');
						firebase.initializeApp({
							apiKey: "AIzaSyAgVLnJGXMy_N7Q1uTYr62-Dp6iFIPZ-I8",
							authDomain: "hop-on01.firebaseapp.com",
							projectId: "hop-on01",
						});
					};

					resolve(initFirebase);
				}, 'firebase');      
			}
		}
	}
});

export default firebasePromise;


// WEBPACK FOOTER //
// ./scripts/firebase-loader.js